import React from "react";
import { FormRow } from "./FormRow";
import { UserShortInfo } from "../../types";
import ManShortSelector from "../../components/ui/shortItemSelect";

interface ResponsibleSelectorProps {
  label: string;
  users: UserShortInfo[];
  selectedUserId: number;
  onChange: (id: number) => void;
}

export const ManSelector: React.FC<ResponsibleSelectorProps> = ({
  label,
  users,
  selectedUserId,
  onChange,
}) => {
  return (
    <FormRow label={label}>
      <ManShortSelector
        items={[...users, { id: 0, name: "Свободно" }]}
        defaultSelectedId={selectedUserId}
        onChangeCallback={onChange}
      />
    </FormRow>
  );
};